import BaseListPage from "../../../base/BaseListPage";
import DiscountDayTimePresenter from "./DiscountDayTimePresenter.js";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter.js";
import Export from "../../../components/Export/index.js";
import printChart from "../../../PrintChart.js";
import Select from "react-select";
import DefaultState from "../../sales-and-transactions/components/DefaultState.js";
import InitialPrompt from "../../../components/InitialPrompt/index.js";
import DiscountByTimeReport from "./components/DiscountTimeByReport.js";
import { exportDiscountTransactionsCSV } from "./utils/discountCsvUtils.js";
import {
  getTimeOfDayDiscountChartData,
  getTimeOfDayDiscountChartOptions,
} from "./utils/timeOfDayChartUtils.js";
import { getTransactionDateRange } from "./utils/dateUtils.js";
import ProgressLoader from "../../../components/ProgressLoader/index.js";
import DateRangeReport from "../../../components/DateRangeReport/index.js";
import PageHeader from "../../../components/PageHeader/index.js";
import CustomSelect from "../../../components/CustomSelect/index.js";
import { addDays, addHours, addMinutes, format, startOfDay } from "date-fns";

class DiscountDayTimePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DiscountDayTimePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );
    this.state = {
      objects: [],
      selectedDate: new Date().toISOString().split("T")[0],
      selectedStoreCode: "",
      store: [],
      storess: "",
      range: "",
      notFound: false,
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", ""),
    );
    return [...new Set(storeCodes)];
  }

  handleDateChange = (event) => {
    const selectedDate = event.target.value;
    this.setState({ selectedDate });
    const range = getTransactionDateRange(selectedDate);
    this.presenter.onChangeDate(range);
  };

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  // filterTransactions(transactions) {
  //   const selectedDate = new Date(this.state.selectedDate);
  //   selectedDate.setHours(0, 0, 0, 0);

  //   return transactions
  //     .filter((obj) => obj.status === "C")
  //     .filter((transaction) => {
  //       const transactionDate = new Date(transaction.tran_date);
  //       transactionDate.setHours(0, 0, 0, 0);

  //       const selectedDateMatch =
  //         transactionDate.getTime() === selectedDate.getTime();
  //       const storeCodeMatch = this.state.selectedStoreCode
  //         ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
  //           this.state.selectedStoreCode
  //         : true;

  //       return selectedDateMatch && storeCodeMatch;
  //     });
  // }

  filterTransactions(transactions) {
    const selectedDate = new Date(this.state.selectedDate);
    selectedDate.setHours(0, 0, 0, 0);

    const startDate = addHours(startOfDay(selectedDate), 5);
    const endDate = addMinutes(addHours(addDays(startDate, 1), -1), 59);

    const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
    const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

    console.log("Selected Date Range: ", {
      $gte: formattedStartDate,
      $lte: formattedEndDate,
    });

    return transactions
      .filter((status) => status.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.tran_date);

        const transactionDateMatch =
          transactionDate >= startDate && transactionDate <= endDate;
        const storeCodeMatch = this.state.selectedStoreCode
          ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
            this.state.selectedStoreCode
          : true;

        // return transactionDateMatch && storeCodeMatch;
        return true;
      });
  }

  countDiscountAmountPerHour = (transactions) => {
    const discountAmounts = new Array(24).fill(0);

    transactions.forEach((transaction) => {
      const hour = new Date(transaction.tran_date).getHours();
      const discountAmount = Number(transaction.discount_amount) || 0;
      discountAmounts[hour] += discountAmount;
    });

    return discountAmounts;
  };

  exportToCSV = () => {
    const { objects } = this.state;
    const filtered = this.filterTransactions(objects);
    exportDiscountTransactionsCSV(filtered);
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }
  render() {
    const { storess, selectedDate } = this.state;
    const filtered = this.filterTransactions(this.state.objects);
    const discountAmountsPerHour = this.countDiscountAmountPerHour(filtered);
    const chartData = getTimeOfDayDiscountChartData(discountAmountsPerHour);
    const chartOptions = getTimeOfDayDiscountChartOptions(chartData);
    const chartId = "chart-container18";
    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <PageHeader
            title="Discount Value vs. Time of Day"
            subtitle="Distribution of discount values across the day"
            icon="bi bi-clock-history"
          />

          <Export
            exportCsv={this.exportToCSV}
            exportPdf={() => printChart(chartId)}
          />
        </div>

        <div className="row mb-2">
          {/* <div className="col-sm-2">
            <input
              className="form-control"
              type="date"
              onChange={this.handleDateChange}
            />
          </div> */}
          <div className="col" style={{ maxWidth: "max-content" }}>
            <DateRangeReport
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>
          <div className="col-sm-4">
            <CustomSelect
              label="Store"
              options={[
                // { value: "AllStore", label: "All Store" },
                ...this.state.store.map((store) => ({
                  value: store.name,
                  label: store.name.replace(/_/g, " "),
                })),
              ]}
              onChange={(selected) => this.onChangeStore(selected.value)}
              // isDisabled={!this.state.range}
              // error={
              //   !this.state.range ? "Please select a date range first" : ""
              // }
              icon="bi bi-shop"
              placeholder="Select Store"
              isClearable={true}
            />
          </div>
        </div>
        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 ? (
          <DiscountByTimeReport
            chartData={chartData}
            chartOptions={chartOptions}
            storess={storess}
            range={this.state.range}
            chartRef={this.chartRef18}
            containerId="chart-container18"
          />
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default withRouter(DiscountDayTimePage);
